import { images } from '../constants'; 

const events = [  
    {
        id: 1,
        image: images.event1,
        title: "Gardening Workshops",
        details: {
            date: "01 Apr, 2024",
            time: "10:00 AM - 4:00 PM",
            location: "Garden Center",
            organizer: "Gardening Workshops",
            number: "+123-456-7890",
            email: "www.website.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Labore Repudiandae Aut Eum Rem Praesentium Doloremque Quos Perferendis Ipsa Sed Placeat Fugiat Minima Tenetur Facilis, Similique, Esse Molestias Harum. Illo, Obcaecati?",
            "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam."
        ],
        gallery: [
            images.event1Gallery1,
            images.event1Gallery2
        ],
        agenda: {
            intro: "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam.",
            points: [
                "Sustainable gardening practices",
                "Effective space planning for gardens",
                "Incorporating native plants",
                "Maximizing outdoor aesthetics",
                "Water conservation techniques"
            ]
        },
        speakers: [
            {
                id: 1,
                image: images.team1,
                name: "David Johnson",
                title: "Garden Expert",
                biography: "David Johnson has been crafting breathtaking gardens for over a decade. His passion for greenery and expertise in landscaping transform outdoor spaces into serene havens. Dedicated to sustainability and aesthetics, David brings life to every project with his meticulous attention to detail.",
                contacts: {
                    phone: "111-222-3344",
                    email: "david.johnson@example.com",
                    website: "www.davidjohnson.com"
                },
                accounts: {
                    facebook: "#",
                    linkedin: "#",
                    twitter: "#",
                    instagram: "#"
                },
                experience: {
                    intro: "Highlights of David’s Landscaping Expertise:",
                    points: [
                        "Eco-friendly garden designs",
                        "Efficient use of outdoor spaces",
                        "Creative plant arrangements",
                        "Sustainable irrigation solutions",
                        "Seamless integration of hardscapes"
                    ]
                },
                skills: [
                    { id: 1, title: "Landscape Design", progress: 95 },
                    { id: 2, title: "Horticulture Expertise", progress: 90 },
                    { id: 3, title: "Customer Service", progress: 85 }
                ]
            },
            {
                id: 2,
                image: images.team2,
                name: "Emily Brown",
                title: "Landscape Specialist",
                biography: "Emily Brown is a passionate landscape specialist known for her ability to design breathtaking outdoor spaces. With a strong focus on sustainability and innovation, she transforms ordinary yards into stunning landscapes that inspire and captivate. Emily’s expertise lies in blending aesthetics with functionality, creating gardens that thrive in harmony with nature.",
                contacts: {
                    phone: "222-333-4455",
                    email: "emily.brown@example.com",
                    website: "www.emilybrown.com"
                },
                accounts: {
                    facebook: "#",
                    linkedin: "#",
                    twitter: "#",
                    instagram: "#"
                },
                experience: {
                    intro: "Key Areas of Emily’s Landscaping Expertise:",
                    points: [
                        "Innovative landscape designs",
                        "Expertise in native plants",
                        "Efficient water management systems",
                        "Integration of hardscaping elements",
                        "Seasonal garden planning"
                    ]
                },
                skills: [
                    { id: 1, title: "Sustainable Design", progress: 95 },
                    { id: 2, title: "Plant Knowledge", progress: 90 },
                    { id: 3, title: "Client Collaboration", progress: 85 }
                ]
            }
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 2,
        image: images.event2,
        title: "Plant Sale",
        details: {
            date: "14 Apr, 2024",
            time: "9:00 AM - 12:00 PM",
            location: "Botanical Gardens",
            organizer: "Plant Sale",
            number: "+123-456-7890",
            email: "www.website.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Labore Repudiandae Aut Eum Rem Praesentium Doloremque Quos Perferendis Ipsa Sed Placeat Fugiat Minima Tenetur Facilis, Similique, Esse Molestias Harum. Illo, Obcaecati?",
            "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam."
        ],
        gallery: [
            images.event2Gallery1,
            images.event2Gallery2
        ],
        agenda: {
            intro: "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam.",
            points: [
                "Exclusive plant varieties",
                "Gardening tips and tricks",
                "Eco-friendly gardening products",
                "Guidance from experts",
                "Discounted plant purchases"
            ]
        },
        speakers: [
            {
                id: 1,
                image: images.team1,
                name: "David Johnson",
                title: "Garden Expert",
                biography: "David Johnson has been crafting breathtaking gardens for over a decade. His passion for greenery and expertise in landscaping transform outdoor spaces into serene havens. Dedicated to sustainability and aesthetics, David brings life to every project with his meticulous attention to detail.",
                contacts: {
                    phone: "111-222-3344",
                    email: "david.johnson@example.com",
                    website: "www.davidjohnson.com"
                },
                accounts: {
                    facebook: "#",
                    linkedin: "#",
                    twitter: "#",
                    instagram: "#"
                },
                experience: {
                    intro: "Highlights of David’s Landscaping Expertise:",
                    points: [
                        "Eco-friendly garden designs",
                        "Efficient use of outdoor spaces",
                        "Creative plant arrangements",
                        "Sustainable irrigation solutions",
                        "Seamless integration of hardscapes"
                    ]
                },
                skills: [
                    { id: 1, title: "Landscape Design", progress: 95 },
                    { id: 2, title: "Horticulture Expertise", progress: 90 },
                    { id: 3, title: "Customer Service", progress: 85 }
                ]
            },
            {
                id: 2,
                image: images.team2,
                name: "Emily Brown",
                title: "Landscape Specialist",
                biography: "Emily Brown is a passionate landscape specialist known for her ability to design breathtaking outdoor spaces. With a strong focus on sustainability and innovation, she transforms ordinary yards into stunning landscapes that inspire and captivate. Emily’s expertise lies in blending aesthetics with functionality, creating gardens that thrive in harmony with nature.",
                contacts: {
                    phone: "222-333-4455",
                    email: "emily.brown@example.com",
                    website: "www.emilybrown.com"
                },
                accounts: {
                    facebook: "#",
                    linkedin: "#",
                    twitter: "#",
                    instagram: "#"
                },
                experience: {
                    intro: "Key Areas of Emily’s Landscaping Expertise:",
                    points: [
                        "Innovative landscape designs",
                        "Expertise in native plants",
                        "Efficient water management systems",
                        "Integration of hardscaping elements",
                        "Seasonal garden planning"
                    ]
                },
                skills: [
                    { id: 1, title: "Sustainable Design", progress: 95 },
                    { id: 2, title: "Plant Knowledge", progress: 90 },
                    { id: 3, title: "Client Collaboration", progress: 85 }
                ]
            }
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 3,
        image: images.event3,
        title: "Garden Tours",
        details: {
            date: "29 Apr, 2024",
            time: "2:00 PM - 5:00 PM",
            location: "Public Gardens",
            organizer: "Garden Tours",
            number: "+123-456-7890",
            email: "www.website.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Labore Repudiandae Aut Eum Rem Praesentium Doloremque Quos Perferendis Ipsa Sed Placeat Fugiat Minima Tenetur Facilis, Similique, Esse Molestias Harum. Illo, Obcaecati?",
            "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam."
        ],
        gallery: [
            images.event3Gallery1,
            images.event3Gallery2
        ],
        agenda: {
            intro: "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam.",
            points: [
                "Guided garden exploration",
                "Introduction to plant species",
                "Photography opportunities",
                "Expert tips on plant care",
                "Scenic outdoor experience"
            ]
        },
        speakers: [
            {
                id: 1,
                image: images.team1,
                name: "David Johnson",
                title: "Garden Expert",
                biography: "David Johnson has been crafting breathtaking gardens for over a decade. His passion for greenery and expertise in landscaping transform outdoor spaces into serene havens. Dedicated to sustainability and aesthetics, David brings life to every project with his meticulous attention to detail.",
                contacts: {
                    phone: "111-222-3344",
                    email: "david.johnson@example.com",
                    website: "www.davidjohnson.com"
                },
                accounts: {
                    facebook: "#",
                    linkedin: "#",
                    twitter: "#",
                    instagram: "#"
                },
                experience: {
                    intro: "Highlights of David’s Landscaping Expertise:",
                    points: [
                        "Eco-friendly garden designs",
                        "Efficient use of outdoor spaces",
                        "Creative plant arrangements",
                        "Sustainable irrigation solutions",
                        "Seamless integration of hardscapes"
                    ]
                },
                skills: [
                    { id: 1, title: "Landscape Design", progress: 95 },
                    { id: 2, title: "Horticulture Expertise", progress: 90 },
                    { id: 3, title: "Customer Service", progress: 85 }
                ]
            },
            {
                id: 2,
                image: images.team2,
                name: "Emily Brown",
                title: "Landscape Specialist",
                biography: "Emily Brown is a passionate landscape specialist known for her ability to design breathtaking outdoor spaces. With a strong focus on sustainability and innovation, she transforms ordinary yards into stunning landscapes that inspire and captivate. Emily’s expertise lies in blending aesthetics with functionality, creating gardens that thrive in harmony with nature.",
                contacts: {
                    phone: "222-333-4455",
                    email: "emily.brown@example.com",
                    website: "www.emilybrown.com"
                },
                accounts: {
                    facebook: "#",
                    linkedin: "#",
                    twitter: "#",
                    instagram: "#"
                },
                experience: {
                    intro: "Key Areas of Emily’s Landscaping Expertise:",
                    points: [
                        "Innovative landscape designs",
                        "Expertise in native plants",
                        "Efficient water management systems",
                        "Integration of hardscaping elements",
                        "Seasonal garden planning"
                    ]
                },
                skills: [
                    { id: 1, title: "Sustainable Design", progress: 95 },
                    { id: 2, title: "Plant Knowledge", progress: 90 },
                    { id: 3, title: "Client Collaboration", progress: 85 }
                ]
            }
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 4,
        image: images.event4,
        title: "Vegetable Gardening Seminars",
        details: {
            date: "07 May, 2024",
            time: "1:00 PM - 3:00 PM",
            location: "Community Center",
            organizer: "Vegetable Gardening Seminars",
            number: "+123-456-7890",
            email: "www.website.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Labore Repudiandae Aut Eum Rem Praesentium Doloremque Quos Perferendis Ipsa Sed Placeat Fugiat Minima Tenetur Facilis, Similique, Esse Molestias Harum. Illo, Obcaecati?",
            "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam."
        ],
        gallery: [
            images.event4Gallery1,
            images.event4Gallery2
        ],
        agenda: {
            intro: "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam.",
            points: [
                "Introduction to vegetable gardening",
                "Planning your garden space",
                "Best soil for vegetable growth",
                "Sustainable gardening techniques",
                "Planting and harvesting tips"
            ]
        },
        speakers: [
            {
                id: 1,
                image: images.team1,
                name: "David Johnson",
                title: "Garden Expert",
                biography: "David Johnson has been crafting breathtaking gardens for over a decade. His passion for greenery and expertise in landscaping transform outdoor spaces into serene havens. Dedicated to sustainability and aesthetics, David brings life to every project with his meticulous attention to detail.",
                contacts: {
                    phone: "111-222-3344",
                    email: "david.johnson@example.com",
                    website: "www.davidjohnson.com"
                },
                accounts: {
                    facebook: "#",
                    linkedin: "#",
                    twitter: "#",
                    instagram: "#"
                },
                experience: {
                    intro: "Highlights of David’s Landscaping Expertise:",
                    points: [
                        "Eco-friendly garden designs",
                        "Efficient use of outdoor spaces",
                        "Creative plant arrangements",
                        "Sustainable irrigation solutions",
                        "Seamless integration of hardscapes"
                    ]
                },
                skills: [
                    { id: 1, title: "Landscape Design", progress: 95 },
                    { id: 2, title: "Horticulture Expertise", progress: 90 },
                    { id: 3, title: "Customer Service", progress: 85 }
                ]
            },
            {
                id: 2,
                image: images.team2,
                name: "Emily Brown",
                title: "Landscape Specialist",
                biography: "Emily Brown is a passionate landscape specialist known for her ability to design breathtaking outdoor spaces. With a strong focus on sustainability and innovation, she transforms ordinary yards into stunning landscapes that inspire and captivate. Emily’s expertise lies in blending aesthetics with functionality, creating gardens that thrive in harmony with nature.",
                contacts: {
                    phone: "222-333-4455",
                    email: "emily.brown@example.com",
                    website: "www.emilybrown.com"
                },
                accounts: {
                    facebook: "#",
                    linkedin: "#",
                    twitter: "#",
                    instagram: "#"
                },
                experience: {
                    intro: "Key Areas of Emily’s Landscaping Expertise:",
                    points: [
                        "Innovative landscape designs",
                        "Expertise in native plants",
                        "Efficient water management systems",
                        "Integration of hardscaping elements",
                        "Seasonal garden planning"
                    ]
                },
                skills: [
                    { id: 1, title: "Sustainable Design", progress: 95 },
                    { id: 2, title: "Plant Knowledge", progress: 90 },
                    { id: 3, title: "Client Collaboration", progress: 85 }
                ]
            }
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 5,
        image: images.event5,
        title: "Garden Maintenance Workshops",
        details: {
            date: "17 May, 2024",
            time: "3:00 PM - 6:00 PM",
            location: "Community Park",
            organizer: "Garden Maintenance Workshops",
            number: "+123-456-7890",
            email: "www.website.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Labore Repudiandae Aut Eum Rem Praesentium Doloremque Quos Perferendis Ipsa Sed Placeat Fugiat Minima Tenetur Facilis, Similique, Esse Molestias Harum. Illo, Obcaecati?",
            "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam."
        ],
        gallery: [
            images.event5Gallery1,
            images.event5Gallery2
        ],
        agenda: {
            intro: "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam.",
            points: [
                "Introduction to garden maintenance",
                "Tools and equipment for garden care",
                "Pruning and trimming techniques",
                "Weed management strategies",
                "Seasonal garden care tips"
            ]
        },
        speakers: [
            {
                id: 1,
                image: images.team1,
                name: "David Johnson",
                title: "Garden Expert",
                biography: "David Johnson has been crafting breathtaking gardens for over a decade. His passion for greenery and expertise in landscaping transform outdoor spaces into serene havens. Dedicated to sustainability and aesthetics, David brings life to every project with his meticulous attention to detail.",
                contacts: {
                    phone: "111-222-3344",
                    email: "david.johnson@example.com",
                    website: "www.davidjohnson.com"
                },
                accounts: {
                    facebook: "#",
                    linkedin: "#",
                    twitter: "#",
                    instagram: "#"
                },
                experience: {
                    intro: "Highlights of David’s Landscaping Expertise:",
                    points: [
                        "Eco-friendly garden designs",
                        "Efficient use of outdoor spaces",
                        "Creative plant arrangements",
                        "Sustainable irrigation solutions",
                        "Seamless integration of hardscapes"
                    ]
                },
                skills: [
                    { id: 1, title: "Landscape Design", progress: 95 },
                    { id: 2, title: "Horticulture Expertise", progress: 90 },
                    { id: 3, title: "Customer Service", progress: 85 }
                ]
            },
            {
                id: 2,
                image: images.team2,
                name: "Emily Brown",
                title: "Landscape Specialist",
                biography: "Emily Brown is a passionate landscape specialist known for her ability to design breathtaking outdoor spaces. With a strong focus on sustainability and innovation, she transforms ordinary yards into stunning landscapes that inspire and captivate. Emily’s expertise lies in blending aesthetics with functionality, creating gardens that thrive in harmony with nature.",
                contacts: {
                    phone: "222-333-4455",
                    email: "emily.brown@example.com",
                    website: "www.emilybrown.com"
                },
                accounts: {
                    facebook: "#",
                    linkedin: "#",
                    twitter: "#",
                    instagram: "#"
                },
                experience: {
                    intro: "Key Areas of Emily’s Landscaping Expertise:",
                    points: [
                        "Innovative landscape designs",
                        "Expertise in native plants",
                        "Efficient water management systems",
                        "Integration of hardscaping elements",
                        "Seasonal garden planning"
                    ]
                },
                skills: [
                    { id: 1, title: "Sustainable Design", progress: 95 },
                    { id: 2, title: "Plant Knowledge", progress: 90 },
                    { id: 3, title: "Client Collaboration", progress: 85 }
                ]
            }
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 6,
        image: images.event6,
        title: "Flower Arranging Workshops",
        details: {
            date: "25 May, 2024",
            time: "6:00 PM - 8:00 PM",
            location: "Botanical Gardens",
            organizer: "Flower Arranging Workshops",
            number: "+123-456-7890",
            email: "www.website.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Labore Repudiandae Aut Eum Rem Praesentium Doloremque Quos Perferendis Ipsa Sed Placeat Fugiat Minima Tenetur Facilis, Similique, Esse Molestias Harum. Illo, Obcaecati?",
            "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam."
        ],
        gallery: [
            images.event6Gallery1,
            images.event6Gallery2
        ],
        agenda: {
            intro: "Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam.",
            points: [
                "Introduction to flower arranging",
                "Choosing the right flowers",
                "Techniques for arranging flowers",
                "Working with vases and containers",
                "Creating themed flower arrangements"
            ]
        },
        speakers: [
            {
                id: 1,
                image: images.team1,
                name: "David Johnson",
                title: "Garden Expert",
                biography: "David Johnson has been crafting breathtaking gardens for over a decade. His passion for greenery and expertise in landscaping transform outdoor spaces into serene havens. Dedicated to sustainability and aesthetics, David brings life to every project with his meticulous attention to detail.",
                contacts: {
                    phone: "111-222-3344",
                    email: "david.johnson@example.com",
                    website: "www.davidjohnson.com"
                },
                accounts: {
                    facebook: "#",
                    linkedin: "#",
                    twitter: "#",
                    instagram: "#"
                },
                experience: {
                    intro: "Highlights of David’s Landscaping Expertise:",
                    points: [
                        "Eco-friendly garden designs",
                        "Efficient use of outdoor spaces",
                        "Creative plant arrangements",
                        "Sustainable irrigation solutions",
                        "Seamless integration of hardscapes"
                    ]
                },
                skills: [
                    { id: 1, title: "Landscape Design", progress: 95 },
                    { id: 2, title: "Horticulture Expertise", progress: 90 },
                    { id: 3, title: "Customer Service", progress: 85 }
                ]
            },
            {
                id: 2,
                image: images.team2,
                name: "Emily Brown",
                title: "Landscape Specialist",
                biography: "Emily Brown is a passionate landscape specialist known for her ability to design breathtaking outdoor spaces. With a strong focus on sustainability and innovation, she transforms ordinary yards into stunning landscapes that inspire and captivate. Emily’s expertise lies in blending aesthetics with functionality, creating gardens that thrive in harmony with nature.",
                contacts: {
                    phone: "222-333-4455",
                    email: "emily.brown@example.com",
                    website: "www.emilybrown.com"
                },
                accounts: {
                    facebook: "#",
                    linkedin: "#",
                    twitter: "#",
                    instagram: "#"
                },
                experience: {
                    intro: "Key Areas of Emily’s Landscaping Expertise:",
                    points: [
                        "Innovative landscape designs",
                        "Expertise in native plants",
                        "Efficient water management systems",
                        "Integration of hardscaping elements",
                        "Seasonal garden planning"
                    ]
                },
                skills: [
                    { id: 1, title: "Sustainable Design", progress: 95 },
                    { id: 2, title: "Plant Knowledge", progress: 90 },
                    { id: 3, title: "Client Collaboration", progress: 85 }
                ]
            }
        ],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    }
];

export default events;